/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: dfe2f50983e9
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * The type of resource.
 */
export const ResourceType = {
  Image: "image",
  Video: "video",
  Raw: "raw",
} as const;
/**
 * The type of resource.
 */
export type ResourceType = ClosedEnum<typeof ResourceType>;

export const ResourceType$zodSchema = z.enum([
  "image",
  "video",
  "raw",
]).describe("The type of resource.");
